<template>
  <div class="container">
    <div class="login_body">
      <h1>用户登录</h1>
      <el-form>
        <el-form-item>
          <el-input placeholder="用户名" v-model="loginParam.userName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="密码" type="password" v-model="loginParam.password"></el-input>
        </el-form-item>
        <div class="login_button" @click="login">登录</div>
      </el-form>

    </div>
  </div>
</template>

<script>
import * as loginApi from '@/api/adminApi/zh/login';
import { mapMutations } from 'vuex';
import * as mutationsType from '@/store/mutations/type';
import { localStorage, sessionStorage } from '@/common/util/storage';

export default {
  data() {
    return {
      loginParam: {}
    };
  },
  methods: {
    login() {
      loginApi.login(this.loginParam).then(res => {
        this.setToken(res.data.token);
        localStorage.set('token', res.data.token);
        loginApi.getUser({ token: res.data.token }).then(result => {
          sessionStorage.set('lng', 'zh-CN');
          this.setLng('zh-CN');
          sessionStorage.userInfo = result.data;
          this.$router.push({
            path: '/admin'
          });
        });
      });
    },
    ...mapMutations({
      setToken: mutationsType.SET_TOKEN,
      setLng: mutationsType.SET_LNG
    })
  }
};
</script>
<style lang="stylus" scoped>
.container {
  height 100%
  width 100%
  background-image url('/static/img/login_bg2.png')
  background-repeat no-repeat
  background-size 100% 100%
  box-sizing border-box
  margin 0
  padding 0
  padding-top 60px
  .login_button {
    width 100%
    margin 0 auto
    text-align center
    cursor pointer
    line-height 40px
    font-size 16px
    font-weight 100
    border-radius 5px
    background-color #f66f26
    color #fff
    border 1px solid rgba(238, 238, 238, 0.41)
    border-width thin
  }
  .login_body {
    width 20%
    margin 170px auto
    padding 40px
    background-color rgba(42, 42, 42, 0.2)
    border-radius 5px
    border-bottom 0
    border-bottom-left-radius initial
    border-bottom-right-radius initial
    height 250px
    h1 {
      color #ffffff
      text-align center
      font-size 22px
      font-weight 300
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/login.vue